import { useEffect, useState } from 'react';
import BinaryOracle from './BinaryOracle.js';

const BinaryOracleOnboardingOverlay = ({
  initialized,
  setInitialized,
  showInfoPanel,
  setShowInfoPanel,
}) => {
  
  const [showPopup, setShowPopup] = useState(false);
  return (
    <>
      {showInfoPanel && (
        <>
          {showPopup && (
            <div
              style={{
                zIndex: 100000,
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '100vw',
                height: '100vh',
                backgroundColor: '#000000aa',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: '#232323',
                  color: '#ddd',
                  padding: '10px',
                  width: '80%',
                  height: '40%',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%,-50%)',
                  overflow: 'auto',
                }}
              >
                <button
                  className={`unstyled-button`}
                  style={{ marginLeft: 'auto', width: '50px' }}
                  onClick={() => setShowPopup(false)}
                >
                  X
                </button>
                <br />
                <p>
                  <strong>
                    The Binary Oracle: A Glitch in the Collective
                    (Un)Consciousness
                  </strong>{' '}
                  centers around an interactive, multilingual AI character born
                  out of the idea that AI represents a mirror of the
                  commercially mined collective unconscious. Like the Oracles of
                  myth, the Binary Oracle offers guidance shrouded in ambiguity,
                  inviting the audience to become both seeker and interpreter.
                  This entity is intended as a glitch in the system, a
                  subversive mirror of the digital age. It unearths the hidden
                  biases and shadowed impulses that pulsate beneath the surface
                  of our networked world. Yet, within its ambiguity lies a
                  challenge – to push beyond the constraints of binarism, to
                  embrace the complexities that transcend simple categorization,
                  and to parse truth from disinformation.
                </p>
                <p>
                  To interact with the Binary Oracle, a price must be paid. “How
                  much water are you willing to pay in exchange for the Oracle’s
                  insight?” This query invites a reflection on the environmental
                  cost implicit in interactions with AI. The quantity of water
                  offered directly influences the Oracle’s response. Weaving
                  cliches, occasional nonsense and cryptic insights, the Oracle
                  reveals four distinct personas based on the user’s offerings.
                  Powered by the very commercially available AI systems that it
                  aims to engage critically, this artwork is at some level a
                  failed intervention. It highlights both the inherent
                  contradictions of relying on a tool built within the system to
                  critique that system and the unseen environmental costs of our
                  digital fascinations.
                </p>

                <p>
                  This artwork was developed within the <nbsp />
                  <a
                    href="https://websites.emerson.edu/data-fluencies/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Data Fluencies Theatre Project
                  </a>
                  .
                </p>
              </div>
            </div>
          )}
          <div id="overlay-container">
            <div id="overlay" className={`overlay`}>
              <div id="centerColumn">
                <img
                  className="logo"
                  src="/assets/binary-oracle/binary-oracle-logo.png"
                  onClick={() => setShowPopup(true)}
                />

                <p>
                  <strong>Lost soul, seeking answers?</strong> The Binary Oracle
                  beckons. But beware, knowledge comes at a price.
                </p>
                <p>
                  Navigate the digital expanse. Explore every corner, for hidden
                  clues may illuminate your path.
                </p>
                <p>
                  When you stand before the Oracle, type your thoughts. Any
                  tongue will do. Remember, the more you share, the clearer the
                  vision.
                </p>
                <p>Grant camera access to fully engage the Oracle's power.</p>

                <p>
                  <strong>Are you ready to face what lies ahead?</strong>
                </p>
                <hr style={{ width: '70%' }} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <h3>Controls</h3>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      paddingBottom: '1em',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <img
                        src="assets/icons/noun-keyboard-8537.svg"
                        width="100px"
                        height="100px"
                      />
                      <em>Move</em>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <img
                        src="assets/icons/noun-mouse-7106231.svg"
                        width="100px"
                        height="100px"
                      />
                      <em>Look</em>
                    </div>
                  </div>
                  <div style={{ paddingBottom: '2em' }}>
                    <em>Access using Chrome with headphones for the best experience.</em>
                  </div>
                </div>
                <hr style={{ width: '70%' }} />
                <button
                  id="startButton"
                  className={'styled-button'}
                  style={{
                    padding: '10px',
                    marginTop: '3em',
                    marginBottom: '5em',
                  }}
                  onClick={() => {
                    if (!initialized) {
                      setInitialized(true);
                    }
                    setShowInfoPanel(false);
                  }}
                >
                  BEGIN
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
// const OnboardingOverlay = ({ initialized, setInitialized }) => {
//   return (
//     <>
//       {!initialized && (
//         <div id="overlay-container">
//           <div id="overlay" className={`overlay`}>
//             <div id="centerColumn">
//               <h1>(Machine) Learning to Be</h1>
//               <p>
//                 “How can we co-exist equitably with AI?” Developed as part of the Data
//                 Fluencies Theatre Project and co-created by a team of artists,
//                 (Machine) Learning to Be is a hybrid, devised multimedia performance
//                 that seeks to challenge established systems of control and explore
//                 alternative modes of engaging with our data-filled world in ways that
//                 open possibilities for more equitable futures alongside AI.
//               </p>
//               <p>
//                 Online and in-person, (Machine) Learning to Be takes audiences on a
//                 multi-world journey, featuring a cast of human and digital characters:
//                 Shadow, Secret Hyena, Scarlet/CamGirl/DeadName, and Binary Oracle.
//                 These diverse characters delve deep into the myriad facets, desires,
//                 concerns, and harms surrounding AI.
//               </p>
//               <p>
//                 This online portal offers an interactive experience structured as a
//                 virtual scavenger hunt. You will explore virtual rooms filled with
//                 clues and elements that delve into the characters’ worlds and provide
//                 glimpses into the performance’s themes and creation process. [The
//                 traces you choose to leave behind will serve to teach a machine
//                 learning system. No identifying data is collected. ??]
//               </p>
//               <button
//                 id="startButton"
//                 onClick={setInitialized}
//               >
//                 BEGIN
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   )
// }
// export default function App() {
//   const [initialized, setInitialized] = useState(false);

//   return (
//     <>

//       <OnboardingOverlay initialized={initialized} setInitialized={setInitialized} />
//       <BinaryOracle initialized={initialized} />

//     </>
//   )
// }
export default function App() {
  const [initialized, setInitialized] = useState(false);
  const [showInfoPanel, setShowInfoPanel] = useState(true);

  return (
    <>
      <BinaryOracleOnboardingOverlay
        initialized={initialized}
        setInitialized={setInitialized}
        showInfoPanel={showInfoPanel}
        setShowInfoPanel={setShowInfoPanel}
      />
      <BinaryOracle
        initialized={initialized}
        setShowInfoPanel={setShowInfoPanel}
      />
    </>
  );
}
